import { Component } from '@angular/core';

@Component({
  selector: 'app-cards-5',
  templateUrl: './cards-5.component.html'
})
export class Cards5Component {




    }
